<template>
  <div class="container-fluid py-4 dashboard-medistock">

    <!-- ================= HEADER ================= -->
    <div class="header-medistock d-flex justify-content-between align-items-center flex-wrap mb-4">

      <div class="d-flex align-items-center gap-3">
        <div class="icon-box">
          <i class="bi bi-hospital fs-2"></i>
        </div>

        <div>
          <h2 class="fw-bold mb-0">MediStock Dashboard</h2>

          <small>
            Suivi global du système
            <span class="badge bg-light text-dark ms-2">
              {{ libellePeriode }}
            </span>
          </small>
        </div>
      </div>

      <!-- ================= FILTRES (EXACT VERSION) ================= -->
      <div class="d-flex align-items-center gap-2 flex-wrap">

        <!-- principaux -->
        <button
          v-for="periode in periodesPrincipales"
          :key="periode.value"
          class="btn btn-filter"
          :class="filtre === periode.value ? 'active' : ''"
          @click="changerFiltre(periode.value)"
        >
          {{ periode.label }}
        </button>

        <!-- secondaires -->
        <div class="dropdown">
          <button class="btn btn-filter dropdown-toggle" data-bs-toggle="dropdown">
            Plus
          </button>

          <ul class="dropdown-menu dropdown-menu-end shadow">
            <li v-for="periode in periodesSecondaires" :key="periode.value">
              <a
                class="dropdown-item"
                href="#"
                @click.prevent="changerFiltre(periode.value)"
              >
                {{ periode.label }}
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- ================= LOADER ================= -->
    <div v-if="isLoading" class="text-center py-5">
      <div class="spinner-border text-success"></div>
      <p>Chargement...</p>
    </div>

    <!-- ================= CONTENT ================= -->
    <div v-else>

      <!-- ================= PRODUITS ================= -->
      <h5 class="section-title">
        <i class="bi bi-capsule me-2"></i>Produits
      </h5>

      <div class="row g-3 mb-4">
        <div class="col-md-4" v-for="card in produitsKpi" :key="card.title">
          <div class="card kpi-card">
            <div class="card-body d-flex justify-content-between">
              <div>
                <small>{{ card.title }}</small>
                <h4>{{ card.value }}</h4>
              </div>
              <i :class="card.icon"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= STOCK ================= -->
      <h5 class="section-title">
        <i class="bi bi-boxes me-2"></i>Stock
      </h5>

      <div class="row g-3 mb-4">
        <div class="col-md-3" v-for="card in stockKpi" :key="card.title">
          <div class="card kpi-card">
            <div class="card-body d-flex justify-content-between">
              <div>
                <small>{{ card.title }}</small>
                <h4>{{ card.value }}</h4>
              </div>
              <i :class="card.icon"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= VENTES ================= -->
      <h5 class="section-title">
        <i class="bi bi-cart-check me-2"></i>Ventes
      </h5>

      <div class="row g-3 mb-4">
        <div class="col-md-4" v-for="card in ventesKpi" :key="card.title">
          <div class="card kpi-card">
            <div class="card-body d-flex justify-content-between">
              <div>
                <small>{{ card.title }}</small>
                <h4>{{ card.value }}</h4>
              </div>
              <i :class="card.icon"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= APPRO ================= -->
      <h5 class="section-title">
        <i class="bi bi-truck me-2"></i>Approvisionnement
      </h5>

      <div class="row g-3 mb-4">
        <div class="col-md-3" v-for="card in approKpi" :key="card.title">
          <div class="card kpi-card">
            <div class="card-body d-flex justify-content-between">
              <div>
                <small>{{ card.title }}</small>
                <h4>{{ card.value }}</h4>
              </div>
              <i :class="card.icon"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= RENTABILITÉ ================= -->
      <h5 class="section-title">
        <i class="bi bi-graph-up-arrow me-2"></i>Rentabilité
      </h5>

      <div class="row g-3 mb-4">
        <div class="col-md-3" v-for="card in rentabiliteKpi" :key="card.title">
          <div class="card kpi-card">
            <div class="card-body d-flex justify-content-between">
              <div>
                <small>{{ card.title }}</small>
                <h4>{{ card.value }}</h4>
              </div>
              <i :class="card.icon"></i>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      isLoading: false,
      filtre: "jour",

      dashboard: {
        produits: {},
        stock: {},
        ventes: {},
        approvisionnement: {},
        rentabilite: {}
      },

      // ================= EXACT FILTERS =================
      periodesPrincipales: [
        { value: "jour", label: "Aujourd'hui" },
        { value: "semaine", label: "Cette semaine" },
        { value: "mois", label: "Ce mois-ci" },
        { value: "annee", label: "Cette année" }
      ],

      periodesSecondaires: [
        { value: "hier", label: "Hier" },
        { value: "semaine_derniere", label: "Semaine dernière" },
        { value: "mois_dernier", label: "Mois dernier" },
        { value: "annee_derniere", label: "Année dernière" }
      ]
    };
  },

  computed: {

    libellePeriode() {
      const all = [...this.periodesPrincipales, ...this.periodesSecondaires];
      return all.find(p => p.value === this.filtre)?.label || this.filtre;
    },

    produitsKpi() {
      const p = this.dashboard.produits || {};
      return [
        { title: "Total", value: p.total ?? 0, icon: "bi bi-capsule text-primary" },
        { title: "Actifs", value: p.actifs ?? 0, icon: "bi bi-check-circle text-success" },
        { title: "Inactifs", value: p.inactifs ?? 0, icon: "bi bi-x-circle text-danger" }
      ];
    },

    stockKpi() {
      const s = this.dashboard.stock || {};
      return [
        { title: "Lots", value: s.lots ?? 0, icon: "bi bi-box text-primary" },
        { title: "Valeur", value: this.money(s.valeur_stock), icon: "bi bi-cash text-success" },
        { title: "Critique", value: s.stock_critique ?? 0, icon: "bi bi-exclamation-circle text-warning" },
        { title: "Ruptures", value: s.ruptures ?? 0, icon: "bi bi-exclamation-triangle text-danger" }
      ];
    },

    ventesKpi() {
      const v = this.dashboard.ventes || {};
      return [
        { title: "Total", value: v.total ?? 0, icon: "bi bi-cart text-primary" },
        { title: "CA", value: this.money(v.chiffre_affaires), icon: "bi bi-currency-exchange text-success" },
        { title: "Quantité", value: v.quantite_vendue ?? 0, icon: "bi bi-boxes text-info" },
        { title: "Annulées", value: v.annulees ?? 0, icon: "bi bi-x-circle text-danger" }
      ];
    },

    approKpi() {
      const a = this.dashboard.approvisionnement || {};
      return [
        { title: "Total", value: a.total ?? 0, icon: "bi bi-truck text-primary" },
        { title: "Quantité", value: a.quantite_entree ?? 0, icon: "bi bi-box-arrow-in-down text-success" },
        { title: "Valeur", value: this.money(a.valeur), icon: "bi bi-wallet text-warning" }
      ];
    },

    rentabiliteKpi() {
      const r = this.dashboard.rentabilite || {};
      return [
        { title: "CA", value: this.money(r.chiffre_affaires), icon: "bi bi-currency-exchange text-primary" },
        { title: "Coût", value: this.money(r.cout_achat), icon: "bi bi-cart-dash text-warning" },
        //{ title: "Bénéfice", value: this.money(r.benefice), icon: "bi bi-graph-up-arrow text-success" },
        //{ title: "Marge", value: `${r.marge ?? 0}%`, icon: "bi bi-percent text-info" }
      ];
    }
  },

  mounted() {
    this.load();
  },

  methods: {

    async load() {
      this.isLoading = true;
      try {
        const res = await api.getItems(`dashboard_data?periode=${this.filtre}`);
        this.dashboard = res?.data || res || {};
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },

    changerFiltre(v) {
      this.filtre = v;
      this.load();
    },

    money(v) {
      return Number(v || 0).toLocaleString("fr-FR") + " FCFA";
    }
  }
};
</script>

<style scoped>
.dashboard-medistock {
  background: #f5f7fb;
  min-height: 100vh;
}

.header-medistock {
  background: linear-gradient(135deg, #0b6b4f, #12a36d);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

.icon-box {
  background: rgba(255,255,255,0.15);
  padding: 10px;
  border-radius: 12px;
}

.btn-filter {
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
}

.btn-filter.active {
  background: white;
  color: #0b6b4f;
}

.section-title {
  margin: 20px 0 10px;
  font-weight: bold;
  color: #1e2a2f;
}

.kpi-card {
  border: none;
  border-radius: 14px;
  background: white;
  box-shadow: 0 6px 18px rgba(0,0,0,0.06);
  transition: 0.2s;
}

.kpi-card:hover {
  transform: translateY(-3px);
}

.kpi-card i {
  font-size: 28px;
  padding: 10px;
  border-radius: 12px;
}
</style>